import { render, staticRenderFns } from "./precasestudy.vue?vue&type=template&id=74341739&scoped=true"
import script from "./precasestudy.vue?vue&type=script&lang=js"
export * from "./precasestudy.vue?vue&type=script&lang=js"
import style0 from "./precasestudy.vue?vue&type=style&index=0&id=74341739&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74341739",
  null
  
)

export default component.exports